"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Jakub Gereg
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var SalesDashboardExcelFileConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SalesDashboardExcelFileConverter, _DataObjectConverter_);

  function SalesDashboardExcelFileConverter() {
    _classCallCheck(this, SalesDashboardExcelFileConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileConverter).apply(this, arguments));
  }

  return SalesDashboardExcelFileConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SalesDashboardExcelFileConverter = SalesDashboardExcelFileConverter;